import { MODULE_LIST, MODULES, type ModuleId } from "@/modules/registry";
import type { ModuleRow } from "@/modules/apps/ModulesManager";

/** Dependency rules between modules (shared by Apps and the console). */
export const isOn = (rows: ModuleRow[], id: ModuleId) =>
  MODULES[id].core === true ||
  rows.some((row) => row.module_id === id && row.enabled);

/** Modules that must be on before `id` (recursive). */
export const missingDependencies = (
  rows: ModuleRow[],
  id: ModuleId,
): ModuleId[] => {
  const missing = new Set<ModuleId>();
  const walk = (moduleId: ModuleId) => {
    for (const dep of MODULES[moduleId].dependsOn) {
      if (!isOn(rows, dep) && !missing.has(dep)) {
        missing.add(dep);
        walk(dep);
      }
    }
  };
  walk(id);
  return [...missing];
};

/** Enabled modules that need `id`. */
export const enabledDependents = (rows: ModuleRow[], id: ModuleId) =>
  MODULE_LIST.filter(
    (module) => module.dependsOn.includes(id) && isOn(rows, module.id),
  );
